export const isFireFox = () =>
  window.navigator?.userAgent?.toLowerCase()?.includes('firefox')
